export const ORDER_ITEM_CATEGORY = {
  HOTEL: 'hotel',
  DOMESTIC_AIR: 'domestic_air',
  FOREIGN_AIR: 'foreign_air',
  SHINKANSEN: 'shinkansen'
} as const;

export type OrderItemCategory = typeof ORDER_ITEM_CATEGORY[keyof typeof ORDER_ITEM_CATEGORY];

export const isFlightCategory = (category: string): boolean => {
  return category === ORDER_ITEM_CATEGORY.DOMESTIC_AIR || category === ORDER_ITEM_CATEGORY.FOREIGN_AIR;
};
